"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * QAS Service
 * <fullname>Jibo QAS API Reference</fullname> <p>This is the <i>Jibo QAS API Reference</i>
 *
 * The version of the OpenAPI document: 3.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QASClientApi = exports.QASClientApiFactory = exports.QASClientApiFp = exports.QASClientApiAxiosParamCreator = exports.ServiceType = exports.QuestionType = exports.PriorityType = exports.MetadataCriteriaTagEnum = exports.MetadataActionRequestActionEnum = exports.IssueType = exports.EnvironmentType = exports.AnnotationStatus = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.AnnotationStatus = {
    Open: 'open',
    Triaged: 'triaged',
    Fixed: 'fixed',
    WontFix: 'wontFix',
    Verified: 'verified',
    Closed: 'closed',
    Deleted: 'deleted'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.EnvironmentType = {
    Test: 'test',
    Production: 'production'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.IssueType = {
    WrongAnswer: 'wrongAnswer',
    MissingAnswer: 'missingAnswer',
    InadequateAnswer: 'inadequateAnswer',
    Other: 'other',
    NoIssue: 'noIssue'
};
exports.MetadataActionRequestActionEnum = {
    Insert: 'insert',
    Update: 'update',
    Delete: 'delete'
};
exports.MetadataCriteriaTagEnum = {
    JiboIdeShared: 'JIBO_IDE_SHARED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.PriorityType = {
    Low: 'low',
    High: 'high',
    Urgent: 'urgent',
    Critical: 'critical'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.QuestionType = {
    User: 'user',
    Qa: 'qa',
    Auto: 'auto'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ServiceType = {
    Qnamaker: 'qnamaker',
    Luis: 'luis',
    Jiboparser: 'jiboparser',
    Mint: 'mint'
};
/**
 * QASClientApi - axios parameter creator
 * @export
 */
var QASClientApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Health check endpoint, used by our infrastructure.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkHealth: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/healthcheck";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get metadata data
         * @param {string} [appName] App Name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetadata: function (appName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/qas/metadata";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearerAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearerAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (appName !== undefined) {
                                localVarQueryParameter['appName'] = appName;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Save annotation data
         * @param {Annotation} annotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processAnnotation: function (annotation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'annotation' is not null or undefined
                            (0, common_1.assertParamExists)('processAnnotation', 'annotation', annotation);
                            localVarPath = "/qas/annotation";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearerAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearerAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(annotation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Process transaction
         * @param {TransactionRequest} transactionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processTransaction: function (transactionRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transactionRequest' is not null or undefined
                            (0, common_1.assertParamExists)('processTransaction', 'transactionRequest', transactionRequest);
                            localVarPath = "/qas/transaction";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearerAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearerAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(transactionRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Edit metadata object
         * @param {MetadataActionRequest} metadataActionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMetadata: function (metadataActionRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'metadataActionRequest' is not null or undefined
                            (0, common_1.assertParamExists)('saveMetadata', 'metadataActionRequest', metadataActionRequest);
                            localVarPath = "/qas/metadata";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearerAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearerAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(metadataActionRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Search annotation
         * @param {AnnotationCriteria} annotationCriteria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAnnotation: function (annotationCriteria, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'annotationCriteria' is not null or undefined
                            (0, common_1.assertParamExists)('searchAnnotation', 'annotationCriteria', annotationCriteria);
                            localVarPath = "/qas/search/annotation";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearerAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearerAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(annotationCriteria, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Search metadata
         * @param {MetadataCriteria} metadataCriteria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMetadata: function (metadataCriteria, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'metadataCriteria' is not null or undefined
                            (0, common_1.assertParamExists)('searchMetadata', 'metadataCriteria', metadataCriteria);
                            localVarPath = "/qas/search/metadata";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearerAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearerAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(metadataCriteria, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Search database
         * @param {TransactionCriteria} transactionCriteria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTransaction: function (transactionCriteria, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'transactionCriteria' is not null or undefined
                            (0, common_1.assertParamExists)('searchTransaction', 'transactionCriteria', transactionCriteria);
                            localVarPath = "/qas/search/transaction";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearerAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearerAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(transactionCriteria, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.QASClientApiAxiosParamCreator = QASClientApiAxiosParamCreator;
/**
 * QASClientApi - functional programming interface
 * @export
 */
var QASClientApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.QASClientApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Health check endpoint, used by our infrastructure.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkHealth: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.checkHealth(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get metadata data
         * @param {string} [appName] App Name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetadata: function (appName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMetadata(appName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Save annotation data
         * @param {Annotation} annotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processAnnotation: function (annotation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.processAnnotation(annotation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Process transaction
         * @param {TransactionRequest} transactionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processTransaction: function (transactionRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.processTransaction(transactionRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Edit metadata object
         * @param {MetadataActionRequest} metadataActionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMetadata: function (metadataActionRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.saveMetadata(metadataActionRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Search annotation
         * @param {AnnotationCriteria} annotationCriteria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAnnotation: function (annotationCriteria, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchAnnotation(annotationCriteria, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Search metadata
         * @param {MetadataCriteria} metadataCriteria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMetadata: function (metadataCriteria, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchMetadata(metadataCriteria, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Search database
         * @param {TransactionCriteria} transactionCriteria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTransaction: function (transactionCriteria, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchTransaction(transactionCriteria, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.QASClientApiFp = QASClientApiFp;
/**
 * QASClientApi - factory interface
 * @export
 */
var QASClientApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.QASClientApiFp)(configuration);
    return {
        /**
         *
         * @summary Health check endpoint, used by our infrastructure.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkHealth: function (options) {
            return localVarFp.checkHealth(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get metadata data
         * @param {string} [appName] App Name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetadata: function (appName, options) {
            return localVarFp.getMetadata(appName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Save annotation data
         * @param {Annotation} annotation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processAnnotation: function (annotation, options) {
            return localVarFp.processAnnotation(annotation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Process transaction
         * @param {TransactionRequest} transactionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processTransaction: function (transactionRequest, options) {
            return localVarFp.processTransaction(transactionRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Edit metadata object
         * @param {MetadataActionRequest} metadataActionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMetadata: function (metadataActionRequest, options) {
            return localVarFp.saveMetadata(metadataActionRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Search annotation
         * @param {AnnotationCriteria} annotationCriteria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAnnotation: function (annotationCriteria, options) {
            return localVarFp.searchAnnotation(annotationCriteria, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Search metadata
         * @param {MetadataCriteria} metadataCriteria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMetadata: function (metadataCriteria, options) {
            return localVarFp.searchMetadata(metadataCriteria, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Search database
         * @param {TransactionCriteria} transactionCriteria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTransaction: function (transactionCriteria, options) {
            return localVarFp.searchTransaction(transactionCriteria, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.QASClientApiFactory = QASClientApiFactory;
/**
 * QASClientApi - object-oriented interface
 * @export
 * @class QASClientApi
 * @extends {BaseAPI}
 */
var QASClientApi = /** @class */ (function (_super) {
    __extends(QASClientApi, _super);
    function QASClientApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Health check endpoint, used by our infrastructure.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QASClientApi
     */
    QASClientApi.prototype.checkHealth = function (options) {
        var _this = this;
        return (0, exports.QASClientApiFp)(this.configuration).checkHealth(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get metadata data
     * @param {string} [appName] App Name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QASClientApi
     */
    QASClientApi.prototype.getMetadata = function (appName, options) {
        var _this = this;
        return (0, exports.QASClientApiFp)(this.configuration).getMetadata(appName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Save annotation data
     * @param {Annotation} annotation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QASClientApi
     */
    QASClientApi.prototype.processAnnotation = function (annotation, options) {
        var _this = this;
        return (0, exports.QASClientApiFp)(this.configuration).processAnnotation(annotation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Process transaction
     * @param {TransactionRequest} transactionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QASClientApi
     */
    QASClientApi.prototype.processTransaction = function (transactionRequest, options) {
        var _this = this;
        return (0, exports.QASClientApiFp)(this.configuration).processTransaction(transactionRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Edit metadata object
     * @param {MetadataActionRequest} metadataActionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QASClientApi
     */
    QASClientApi.prototype.saveMetadata = function (metadataActionRequest, options) {
        var _this = this;
        return (0, exports.QASClientApiFp)(this.configuration).saveMetadata(metadataActionRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Search annotation
     * @param {AnnotationCriteria} annotationCriteria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QASClientApi
     */
    QASClientApi.prototype.searchAnnotation = function (annotationCriteria, options) {
        var _this = this;
        return (0, exports.QASClientApiFp)(this.configuration).searchAnnotation(annotationCriteria, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Search metadata
     * @param {MetadataCriteria} metadataCriteria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QASClientApi
     */
    QASClientApi.prototype.searchMetadata = function (metadataCriteria, options) {
        var _this = this;
        return (0, exports.QASClientApiFp)(this.configuration).searchMetadata(metadataCriteria, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Search database
     * @param {TransactionCriteria} transactionCriteria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QASClientApi
     */
    QASClientApi.prototype.searchTransaction = function (transactionCriteria, options) {
        var _this = this;
        return (0, exports.QASClientApiFp)(this.configuration).searchTransaction(transactionCriteria, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return QASClientApi;
}(base_1.BaseAPI));
exports.QASClientApi = QASClientApi;
